export const dashboardWidgets = {
  upcoming: {
    title: "Arrivées à venir",
    empty: "Aucun événement à venir",
    createBooking: "Créer une réservation",
  },
  lastActivity: {
    title: "Dernière activité",
  },
  portals: {
    title: "Canaux de réservation synchronisés",
    connectedSuccess: "Connecté avec succès",
    unknownChannel: "Inconnu",
    connectNewChannel: "Connecter un nouveau canal",
    empty: "Vous n'avez aucun canal synchronisé",
    connectChannel: "Connecter un canal",
    loadError: "Les portails n'ont pas pu être chargés",
    errorTitle: "Erreur",
  },
};
